
angular.module('Services')
    .factory('Packages', function ($http, $rootScope, Error, Request) {
        return {
            getList: function(callback) {
                Request.get({
                    url: ApiURLs.packaging,
                    successCallback: callback,
                    errorCallback: callback
                });
            },
            getPackage: function(id, callback) {
                Request.get({
                    url: ApiURLs.packaging + id + '/',
                    successCallback: callback,
                    errorCallback: callback
                });
            },
            savePackage: function(data, callback, errCallback) {
                Request.post({
                    url: ApiURLs.packaging,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errCallback
                }, data);
            },
            newPackage: function(data) {
                var pack = {};
                for (var i in data) {
                    switch(i) {
                        case "name":
                        case "length":
                        case "width":
                        case "height":
                        case "measureUnit":
                        case "maxWeight":
                        case "weightUnit":
                        case "cartonisation":
                        case "display":
                        case "displayOrder":
                            pack[i] = data[i];
                            break;
                        case "measure":
                            if (data.measure) {
                                for (var i in data.measure.values) {
                                    pack[i] = data.measure.values[i];
                                }
                            }
                            break;
                    }
                }
                return pack;

            }
        }
    });


// WEBPACK FOOTER //
// ./js/services/packages.js